import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { isObject, path } from '@uswitch/ev-utils/obj';
/**
 * The type of the value, either an absolute value 'value', or a reference value 'valueFrom'.
 *
 * @typedef {string|null} ValueType
 */

/**
 * The value, either an absolute value, or a reference value.
 *
 * @typedef {*} Value
 */

/**
 * Takes an object slice from the schema, and finds whether the slice is a 'value' or 'valueFrom'
 * type.
 *
 * @param {Object} slice
 * @param {*] [slice.value] - The absolute value.
 * @param {string} [slice.valueFrom] - The path to the value on the dataset.
 * @returns {[ValueType, Value]}
 */

export var getValueType = function getValueType(slice) {
  if (!isObject(slice)) {
    return [null, null];
  }

  if ({}.hasOwnProperty.call(slice, 'valueFrom')) {
    return ['valueFrom', slice.valueFrom];
  }

  if ({}.hasOwnProperty.call(slice, 'value')) {
    return ['value', slice.value];
  }

  if ({}.hasOwnProperty.call(slice, 'valueCalculated')) {
    return ['valueCalculated', slice.valueCalculated];
  }

  if ({}.hasOwnProperty.call(slice, 'compound')) {
    return ['compound', JSON.stringify(slice.compound)];
  }

  return [null, null];
};
/**
 * Takes an object slice from the schema, along with the dataset, and returns the absolute value,
 * either from the dataset or the schema.
 *
 * @param {Object} slice
 * @param {*] [slice.value] - The absolute value.
 * @param {string} [slice.valueFrom] - The path to the value on the dataset.
 * @param {Object} dataset - The dataset to lookup.
 * @returns {[Value, ValueType]}
 */

export var getValue = function getValue(slice, dataset) {
  var _getValueType = getValueType(slice),
      _getValueType2 = _slicedToArray(_getValueType, 2),
      type = _getValueType2[0],
      value = _getValueType2[1];

  if (type === 'valueFrom') {
    return path(value.split('.'), dataset, null);
  }

  return value;
};
export var getField = function getField(slice) {
  return getValueType(slice)[1];
};
export var getDisabledValue = function getDisabledValue(slice, dataset) {
  if (!slice) {
    return false;
  }

  return !getValue(slice, dataset);
};
//# sourceMappingURL=utils.js.map